export const CHECKOUT_PATH = '/checkout';
export const checkoutPath = `${CHECKOUT_PATH}/:linkToken`;
export const checkoutDisplayPath = (displayId) => `${CHECKOUT_PATH}/${displayId}`;
